<template>
  <div class="express-car">
    <HomeTitle :data="titleData" @moreHandle="moreHandle"></HomeTitle>
    <div class="express-container">
      <div class="express-box" v-for="(item, index) in data" :key="index" @click="locationTo(item.busurl)">
        <p class="express-name">{{ item.busname }}</p>
        <p class="express-describe">{{ item.deptname }}</p>
        <span class="iconbox">
            <img
              class="icon-img"
              onload="SVGInject(this)"
              round fit="cover"
              :src="complete(item.buspic)"
            />
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import {complete, baseURL} from "@/utils/url"
import * as svg from '@/utils/svg-inject.min'
import { getExpress } from '@/api/home/index'
import {locationTo} from "@/utils/url"
export default {
  name: "ExpressCar",
  components: {
    HomeTitle: () => import('./HomeTitle')
  },
  props: ['title'],
  data() {
    return {
      titleData: {
        title: this.title,
        more: true
      },
      data: []
    }
  },
  created() {
    this.getThematicServiceList();
  },
  methods: {
    complete,
    locationTo,
    // 获取服务列表
    getThematicServiceList() {
      getExpress('ztc').then(res => {
        if (res && res.code == 200) {
          this.data = res.data;
        }
      })
    },
    // 更多点击事件
    moreHandle() {
      this.$router.push("/expresscar");
    },
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/css/theme/theme.scss';
.express-container{
  padding: 15px 0;
  display: flex;
  flex-wrap: wrap;
  .express-box {
    position: relative;
    width: 86px;
    height: 60px;
    padding: 15px 65px 15px 15px;
    flex-shrink: 0;
    background: #FAFAFA;
    border-radius: 5px;
    margin-right: 13px;
    margin-bottom: 13px;
    &:nth-child(2n){
      margin-right: 0;
    }
    p{
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      &.express-name{
        height: 30px;
        line-height: 30px;
        font-size: 14px;
        font-weight: 600;
      }
      &.express-describe{
        height: 25px;
        line-height: 25px;
        font-size: 12px;
        color: #999;
      }
    }
    .iconbox {
      display: block;
      width: 40px;
      height: 40px;
      position: absolute;
      right: 15px;
      bottom: 15px;
  
      img, svg {
        display: block;
        width: 40px;
        height: 40px;
        fill: #003d88;
      }
    }
  }
}
</style>
